import { orderBy } from 'lodash';
import { GroupType, ProductType, Program } from '@monorepo/types';
import { getEnv, getRoot } from '@hub/helpers/getters.store';
import GroupService from '@hub/services/entities/group-service';
import { EntityStore } from '../base/entity-store';

export class GroupStore extends EntityStore<GroupService, GroupType> {
  constructor() {
    const {
      apiFactory: { groupService },
    } = getEnv();

    super(groupService);
  }

  setGroups(groups: GroupType[]) {
    this._items = new Map(groups.map((group) => [group._id, group]));
  }

  get groups() {
    return this.items as GroupType[];
  }

  get availableProgramGroups() {
    const {
      uiStore: { productStore },
    } = getRoot();

    const filteredGroups = this.items.filter((group) => {
      const currentGroupPrograms = productStore.getAvailableProducts(
        ProductType.Program,
        group.name,
      );
      return currentGroupPrograms.some(
        (program) => (program as Program).sellable,
      );
    });

    return orderBy(filteredGroups, ['displayOrder']);
  }

  getGroupByName(groupName?: string) {
    if (!groupName) {
      return undefined;
    }

    return this.items.find((group) => group.name === groupName);
  }

  findById(id?: string) {
    return this.items.find((group) => group._id === id);
  }
}
